/************************************
 ** Control the Energy label modal **
 ************************************/

document.addEventListener('DOMContentLoaded', function () {

  var energyIcon = document.getElementById('energy_icon');
  var energyModal = document.getElementById('energy_modal');
  var energyClose = document.querySelector('.energy_close');

  var infoIcon = document.getElementById('info_icon');
  var infoModal = document.getElementById('info_modal');
  var infoClose = document.querySelector('.info_close');

  /* Force modals outside Enterprise stacking context */
  if (energyModal) {
    document.body.appendChild(energyModal);
  }

  if (infoModal) {
    document.body.appendChild(infoModal);
  }

  if (energyIcon && energyModal && energyClose) {
    energyIcon.addEventListener('click', function (e) {
      e.stopPropagation();
      energyModal.style.display = 'block';
    });

    energyClose.addEventListener('click', function () {
      energyModal.style.display = 'none';
    });

    energyModal.addEventListener('click', function (e) {
      if (e.target === energyModal) {
        energyModal.style.display = 'none';
      }
    });
  }

  if (infoIcon && infoModal && infoClose) {
    infoIcon.addEventListener('click', function (e) {
      e.stopPropagation();
      infoModal.style.display = 'block';
    });

    infoClose.addEventListener('click', function () {
      infoModal.style.display = 'none';
    });

    infoModal.addEventListener('click', function (e) {
      if (e.target === infoModal) {
        infoModal.style.display = 'none';
      }
    });
  }

});